import React, { useMemo } from 'react';
import { Typography, Collapse, LoaderAnimation, Row, Col } from '../../../../../components';
import { UPLOAD_STATUS } from '../../../../../constants/discovery';
import { formatCount } from '../../../helpers';

import './ImportHistory.scss';

const { Title, Paragraph, Text } = Typography;

export const ImportHistory = ({ historyData, isLoading }) => {
    const formatDateTime = useMemo(
        () => (dateString) => {
            const date = new Date(dateString);
            const formatted = `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date
                .getDate()
                .toString()
                .padStart(
                    2,
                    '0',
                )}/${date.getFullYear()} - ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

            return formatted;
        },
        [],
    );

    const historyItems = useMemo(
        () =>
            historyData?.map((entry, index) => ({
                key: `${index + 1}`,
                label: (
                    <div className="import-label">
                        <Text className="import-title">{entry.import_name || `RV Tools Import ${index + 1}`}</Text>
                        <Text className="import-date">Date: {formatDateTime(entry.created_at)}</Text>
                        <Text className="import-status">Status: {UPLOAD_STATUS[entry.status]}</Text>
                    </div>
                ),
                children: (
                    <div>
                        <Paragraph>
                            <span className="text-light">Uploaded By:</span> {entry.created_by}
                        </Paragraph>
                        <Paragraph>
                            <span className="text-light">Number of machines:</span> {formatCount(entry.vm_total_count)}
                        </Paragraph>
                        {entry.error_details && (
                            <Paragraph className="error-details-container">
                                <span className="error-details-label">Error info:&nbsp;</span>
                                <span className="error-details-content">
                                    {entry.error_details.replace(/\\n/g, '\n')}
                                </span>
                            </Paragraph>
                        )}
                    </div>
                ),
            })),
        [historyData, formatDateTime],
    );

    if (isLoading) {
        return <LoaderAnimation size="small" />;
    }

    return (
        <Row>
            <Col span={20}>
                <section className="import-history">
                    <Title level={2}>History</Title>
                    <Collapse defaultActiveKey={[]} items={historyItems} />
                </section>
            </Col>
        </Row>
    );
};
